/* eslint-disable */
export default {
  cancel: 'Annuler',
  reply: 'Répondre',
  onMyWay: 'Sur la route',
  customMessage: 'Message personnalisé',
  callMeBackIn: 'Rappelez-moi dans',
  willCallYouBackIn: 'Je vous rappelle dans',
  min: 'min',
  hours: 'heures',
  days: 'jours',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
